import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Account, Channel } from '@/shared/model/scrap-agent.model';
import MultiSelect from '@/shared/multi-select/multi-select.vue';

@Component({
  components: { DsModal, MultiSelect },
})
export default class ScrapAgentFacebookAccount extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Object, default: () => ({}) }) userEdit!: any;

  showModal: boolean = this.open;
  formData = {
    newFeed: true,
    groupId: '',
  };

  selectedDataTypes = [];

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
  }

  @Watch('showModal')
  onShowModalChange(value: boolean) {
    this.$emit('update:open', value);
  }

  handleCloseModal() {
    this.$emit('modal:close');
  }

  handleBack() {
    this.$emit('modal:back');
  }

  handleDataType() {
    const dataSourceTypes: string[] = [];

    if (this.formData.newFeed) {
      dataSourceTypes.push('NEW_FEED');
    }

    // if (this.formData.myProfile) {
    //   dataSourceTypes.push('PROFILE');
    // }

    return dataSourceTypes;
  }

  handleNext() {
    const types = this.handleDataType();

    // Create data sources array from selected types
    const newDataSources = types.map(type => {
      return { dataSourceTypes: [type], value: null, dataSourceAccStatus: 1, descriptionEn: 'New feed' };
    });
    console.log(this.userEdit, 'this.userEdit');

    const value = {
      channelId: null,
      channelName: 'Facebook',
      channelDescription: 'Facebook Account',
      channelImageUri: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/facebook.png',
      channelType: 'FACEBOOK',
      allowAccess: 'true',
      accounts: [
        {
          accountId: this.userEdit.accountId,
          accountName: this.userEdit.fullName || 'Facebook User',
          fullName: this.userEdit.fullName || 'Facebook User',
          dataSource: newDataSources,
          password: this.userEdit.authorizationCode,
          isScrap: true,
        },
      ],
    };

    this.$emit('addItemFacebook', value);
    this.$emit('modal:ok');
  }
}
